class HeaderSearchModal extends HTMLElement {
  constructor() {
    super();

    this.openButton = this.querySelector('[data-search-modal-open]');
    this.dialog = this.querySelector('[data-search-modal-dialog]');
    this.overlay = this.querySelector('[data-search-modal-overlay]');
    this.closeButton = this.querySelector('[data-search-modal-close]');
    this.content = this.querySelector('[data-search-modal-content]');
    this.input = this.querySelector('[data-search-modal-input]') || this.querySelector('input:not([type="hidden"])');
    this.focusToggleOnClose = false;

    if (!this.openButton || !this.dialog) return;

    this.openButton.addEventListener('click', this.onToggleClick.bind(this));
    this.closeButton?.addEventListener('click', () => this.close());
    this.dialog.addEventListener('cancel', this.onDialogCancel.bind(this));
    this.dialog.addEventListener('close', this.onDialogClose.bind(this));
  }

  isOpen() {
    return Boolean(this.dialog?.open);
  }

  onToggleClick(event) {
    event.preventDefault();
    this.isOpen() ? this.close() : this.open();
  }

  onDialogCancel(event) {
    event.preventDefault();
    this.close();
  }

  onDialogClose() {
    const focusToggle = this.focusToggleOnClose;
    this.focusToggleOnClose = false;
    this.syncClosedState(focusToggle);
  }

  open() {
    if (!this.dialog || this.dialog.open) return;

    const header = this.closest('.header-wrapper');
    if (header) {
      header.preventHide = true;
      const headerBottom = Math.floor(header.getBoundingClientRect().bottom);
      this.style.setProperty('--header-bottom-position-desktop', `${headerBottom}px`);
    }

    this.setAttribute('open', '');

    try {
      this.dialog.showModal();
    } catch (error) {
      this.syncClosedState(false);
      return;
    }

    document.body.classList.add('overflow-hidden');
    trapFocus(this.content || this.dialog, this.input || this.content || this.dialog);
  }

  close(focusToggle = true) {
    if (!this.dialog) return;

    this.focusToggleOnClose = focusToggle;

    if (!this.dialog.open) {
      this.syncClosedState(focusToggle);
      this.focusToggleOnClose = false;
      return;
    }

    this.dialog.close();
  }

  syncClosedState(focusToggle = false) {
    const header = this.closest('.header-wrapper');
    if (header) header.preventHide = false;

    this.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');
    removeTrapFocus(focusToggle ? this.openButton : null);
  }
}

customElements.define('header-search-modal', HeaderSearchModal);
